webpackJsonp([71624090486659],{

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookConnections = __webpack_require__(35);
	
	var _LoreHookConnections2 = _interopRequireDefault(_LoreHookConnections);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookConnections2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'casingStyle'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Casing style used by the framework when composing API endpoints.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Since models are camelCased in Lore, the framework assumed the server uses camelCasing as well. For example, if you have a model called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'bookAuthor'
	      ),
	      ', and pluralization is turned off, the framework will assume the endpoint is located at ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/bookAuthor'
	      ),
	      '. If the endpoint is something else, like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/book_author'
	      ),
	      'you will need to tell the framework to modify its convention.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      casingStyle |  endpoint\n      ---------------------------\n        camel     |  /book_author\n        kebab     |  /book-author\n        pascal    |  /bookAuthor\n        snake     |  /BookAuthor\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-connections-config-casing-style-js-b61848a330fc87d26d42.js